import React, { useRef, useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import logo from "./Userlayout/TOSC_white.png";
import Chip from "@mui/material/Chip";
import { alpha, styled } from "@mui/material/styles";
import { TextField, Typography, Divider } from "@mui/material";
import { Grid, Button, Card } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import GoogleIcon from "@mui/icons-material/Google";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CssTextField = styled(TextField)({
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "#f0f0f0",
    color: "#000",
  },
  "& label.Mui-focused": {
    color: "grey",
    input: {
      color: "white",
    },
  },
  "& label.Mui": {
    color: "white",
    input: {
      color: "white",
    },
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "white",
    color: "white",
    input: {
      color: "white",
    },
  },
  "& .MuiFormLabel-root": {
    borderBottomColor: "white",
    color: "grey",
    input: {
      color: "white",
    },
  },
  "& .MuiOutlinedInput-root": {
    input: {
      color: "white",
    },
    "& fieldset": {
      borderColor: "grey",
      color: "white",
    },
    "&:hover fieldset": {
      borderColor: "grey",
      color: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1976d2",
      color: "white",
      input: {
        color: "white",
      },
    },
    "&.MuiInputBase-input fieldset": {
      borderColor: "white",
      color: "white",
      input: {
        color: "white",
      },
    },
  },
});

export default function Signup() {
  const [all_orders, setAllOrders] = useState([]);
  const navigate = useNavigate();
  const [openMessage, setOpenMessage] = React.useState(true);
  const [open, setOpen] = React.useState(true);

  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const { signup, currentUser } = useAuth();
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Check if user is already authenticated on component mount
  useEffect(() => {
    if (currentUser) {
      navigate("/dashboard", { replace: true });
    }
  }, [currentUser, navigate]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleCloseMessage = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenMessage(false);
  };

  async function handleSubmit(e) {
    e.preventDefault();

    if (passwordRef.current.value.length < 6) {
      setOpen(true);
      setError("Password too short, at least 6 characters are required.");
      return;
    }

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      setOpen(true);
      setError("Passwords do not match");
      return;
    }

    try {
      setError("");
      setLoading(true);

      const email = emailRef.current.value;
      const password = passwordRef.current.value;

      // Create user with Firebase Authentication and store user data in students collection
      await signup(email, password);

      // Ensure immediate redirection to dashboard
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setOpen(true);
      console.error("Signup error:", err);
      setError(err.message || "Failed to create an account");
    } finally {
      setLoading(false);
    }
  }

  // If user is already authenticated, show loading or redirect immediately
  if (currentUser) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      className="login-gl"
      sx={{
        backgroundImage: `url('your-background-image-path')`,
        backgroundSize: "cover",
        height: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        className="dashboard-card"
        sx={{
          padding: 4,
          width: 400,
        }}
      >
        <Box
          sx={{
            color: "white",
            textAlign: "center",
            fontSize: "1.5rem",
          }}
        >
          <a href="https://tosc.techkriti.org">
            {" "}
            <img src={logo} alt="TOSC logo" style={{ width: "300px" }} />
          </a>

          <h2 className="text-center mb-4">Sign up</h2>
        </Box>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && (
              <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
              >
                <Alert
                  onClose={handleClose}
                  severity="error"
                  sx={{ width: "100%" }}
                >
                  {error}
                </Alert>
              </Snackbar>
            )}
            {message && (
              <Snackbar
                open={openMessage}
                autoHideDuration={60000}
                onClose={handleCloseMessage}
              >
                <Alert
                  onClose={handleCloseMessage}
                  severity="success"
                  sx={{ width: "100%" }}
                >
                  Successfully Registered. Go to login page.
                </Alert>
              </Snackbar>
            )}

            <Form.Group id="email" className="login-input">
              <CssTextField
                label="Email"
                type="email"
                inputRef={emailRef}
                fullWidth
                sx={{ mb: 2, zIndex: 3 }}
              />
            </Form.Group>

            {/* <Form.Group id="name" className="login-input">
              
              <CssTextField
              label="Name"
              type="name"
              inputRef={nameref}
              fullWidth
              sx={{ mb: 2, zIndex: 3 }}
            />
            </Form.Group> */}

            {/* <Form.Group id="phone" className="login-input">
              
              <CssTextField
              label="Phone"
              type="phone"
              inputRef={phoneref}
              fullWidth
              sx={{ mb: 2, zIndex: 3 }}
            />
            </Form.Group> */}

            <Form.Group id="password" className="login-input">
              <CssTextField
                label="Password"
                type="password"
                inputRef={passwordRef}
                fullWidth
                sx={{ mb: 2, zIndex: 3 }}
              />
            </Form.Group>

            <Form.Group id="password-confirm" className="login-input">
              <CssTextField
                label="Confirm Password"
                type="password"
                inputRef={passwordConfirmRef}
                fullWidth
                sx={{ mb: 2, zIndex: 3 }}
              />
            </Form.Group>

            <Button
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              type="submit"
              disabled={loading}
              sx={{ mb: 2 }}
            >
              Sign Up
            </Button>

            <Divider sx={{ my: 2, color: "rgba(255, 255, 255, 0.5)" }}>
              OR
            </Divider>

            {/* <Button
              variant="outlined"
              fullWidth
              size="large"
              startIcon={<GoogleIcon />}
              onClick={handleGoogleSignIn}
              disabled={loading}
              sx={{ 
                mb: 2,
                color: "white",
                borderColor: "rgba(255, 255, 255, 0.3)",
                "&:hover": { borderColor: "rgba(255, 255, 255, 0.8)" }
              }}
            >
              Sign up with Google
            </Button> */}

            <Box
              textAlign="center"
              sx={{ paddingTop: 4 }}
              fontFamily={"sans-serif"}
            >
              Already registered?{" "}
              <Link
                to="/login"
                style={{ textDecoration: "none", color: "blue" }}
              >
                Login
              </Link>
            </Box>
          </form>
        )}
      </Box>
    </Box>
  );
}
